import styles from "./CreateAlbumSubsection01.module.css";
const CreateAlbumSubsection01 = ({
  disableTextBox,
  textBoxContent = "",
  handleTextChange,
}) => {
  return (
    <div className={styles.album_subsec01_div}>
      <div className={styles.album_subsec01_textContent_top}>
        タイトルを入力し、アップロードする写真を選択してアップロードしてください。
        <div className={styles.album_subsec01_textContent_bottom}>
          １回のアップロード可能な枚数は２０枚までです。
        </div>
      </div>
      <div className={styles.album_subSec01_textBox_div}>
        <div className={styles.album_subSec01_textBox_text}>タイトル入力</div>
        <div className={styles.album_subSec01_textBox_textBoxContainer}>
          <input
            type={"text"}
            value={textBoxContent}
            style={styles.album_subSec01_textBox}
            disabled={disableTextBox}
            onChange={handleTextChange}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default CreateAlbumSubsection01;
